import {ACTION_TYPE} from "utils/constants";

const initialState = {
  currentTab: "world",
};

export default function layer(state = initialState, action) {
  switch (action.type) {
    case ACTION_TYPE.SELECT_LAYER_TAB:
      return {
        ...state,
        currentTab: action.payload,
      };

    default:
      return state;
  }
}
